import {animate, style, transition, trigger} from '@angular/animations';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {fade, slideUp} from '@shared/tabs/animations/animations';

@Component({
  selector: 'app-overlay-side-panel',
  templateUrl: './overlay-side-panel.component.html',
  styleUrls: ['./overlay-side-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    fade,
    slideUp,
    trigger('content', [
      transition(':enter', [
        style({
          transform: 'translateX(100%)',
          opacity: 0,
          alignItems: 'center',
        }),
        animate(
          '500ms cubic-bezier(.61, .29, .07, 1.02)',
          style({
            transform: 'translateX(0)',
            opacity: 1,
          }),
        ),
      ]),
    ]),
  ],
})
export class OverlaySidePanelComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
